const translation = {
  // Top bar
  topBar: "Nền tảng B2B xuất khẩu Hàn Quốc → Việt Nam | 한-베 B2B 수출 플랫폼",

  // Navigation
  nav: {
    newProducts: "한국 신상품",
    newProductsVn: "Sản Phẩm Mới HQ",
    companies: "한국기업 소개",
    companiesVn: "Giới Thiệu DN HQ",
    techCoop: "기술협력",
    techCoopVn: "Hợp Tác Kỹ Thuật",
    activities: "협회활동 소개",
    activitiesVn: "Giới Thiệu Hiệp Hội",
    partner: "한국 파트너 신청",
    partnerVn: "Đăng Ký Đối Tác HQ",
    register: "무료회원 가입",
    registerVn: "Đăng Ký Miễn Phí",
    searchPlaceholder: "Tìm kiếm sản phẩm, doanh nghiệp HQ...",
    login: "Đăng Nhập",
    allCategories: "Tất cả",
    stats1: "382 Doanh Nghiệp",
    stats2: "999+ Sản Phẩm/Danh Mục",
    categoryMenu: "Danh Mục Sản Phẩm",
    viewAllCount: "Xem tất cả",
    totalProducts: "Tổng",
    inCategory: "sản phẩm trong danh mục này",
    viewAllProducts: "Xem Tất Cả Sản Phẩm →",
    featured: "Nổi Bật",
    newProductBanner: "Sản Phẩm Mới Nhất",
    newProductBannerSub: "Cập nhật hàng tuần từ các DN HQ hàng đầu",
    exploreNow: "Khám phá ngay",
  },

  // Hero Section
  hero: {
    announcement: "🇰🇷 Nền Tảng B2B Xuất Khẩu Hàng Đầu Hàn Quốc → Việt Nam",
    title1: "Kết Nối Doanh Nghiệp",
    title2: "Hàn Quốc – Việt Nam",
    subtitle: "Khám phá hàng nghìn sản phẩm công nghệ cao từ 382+ doanh nghiệp Hàn Quốc uy tín. Nền tảng B2B chuyên biệt cho thị trường Việt Nam.",
    cta1: "Khám Phá Sản Phẩm",
    cta2: "Đăng Ký Miễn Phí",
    stat1: "Doanh Nghiệp HQ",
    stat2: "Sản Phẩm",
    stat3: "Đối Tác VN",
    stat4: "Năm Kinh Nghiệm",
  },

  // Category Grid
  category: {
    title: "Danh Mục Sản Phẩm",
    subtitle: "8 nhóm ngành hàng công nghệ cao từ Hàn Quốc",
    viewAll: "Xem Tất Cả",
    products: "sản phẩm",
  },

  // Featured Products
  featured: {
    title: "Sản Phẩm Nổi Bật",
    subtitle: "Được chọn lọc từ các doanh nghiệp Hàn Quốc hàng đầu",
    viewMore: "Xem Thêm Sản Phẩm",
    new: "MỚI",
    hot: "HOT",
    contactPrice: "Liên hệ để biết giá",
    viewDetail: "Xem Chi Tiết",
    inquiry: "Gửi Yêu Cầu",
    contactZalo: "Chat Zalo ngay",
    registerConsultation: "Đăng Ký Tư Vấn",
    sendInquiry: "Gửi Yêu Cầu Tư Vấn",
    comments: "bình luận",
  },

  // Quick Access
  quickAccess: {
    flashSale: "Flash Sale",
    newArrival: "Hàng Mới Về",
    topSeller: "Bán Chạy",
    certified: "Chứng Nhận",
    partner: "Đối Tác",
    techCoop: "Hợp Tác KT",
    association: "Hiệp Hội",
    support: "Hỗ Trợ",
  },

  // Stats
  stats: {
    title: "Nền Tảng B2B Uy Tín Nhất Hàn-Việt",
    subtitle: "Được tin tưởng bởi hàng trăm doanh nghiệp từ cả hai quốc gia",
    companies: "Doanh Nghiệp HQ",
    products: "Sản Phẩm",
    partners: "Đối Tác VN",
    years: "Năm Hoạt Động",
  },

  // Product Detail
  product: {
    companyInfo: "Thông Tin Doanh Nghiệp",
    companyCode: "Mã DN",
    managerCode: "Mã Quản Lý",
    phone: "Điện Thoại",
    email: "Email",
    category: "Danh Mục",
    subCategory: "Phân Mục",
    registeredDate: "Ngày Đăng",
    tags: "Nhãn",
    sendInquiry: "Gửi Yêu Cầu Tư Vấn",
    contactConsultation: "Liên hệ tư vấn",
    viewCompanyWebsite: "Tham khảo link sản phẩm gốc",
    price: "Giá Bán",
    description: "Mô Tả Sản Phẩm",
    comments: "Bình Luận & Tư Vấn",
    addComment: "Thêm Bình Luận",
    yourName: "Họ và tên",
    yourComment: "Nội dung bình luận hoặc câu hỏi...",
    submit: "Gửi Bình Luận",
    adminReply: "Phản hồi từ Ban Quản Trị",
    noComments: "Chưa có bình luận. Hãy là người đầu tiên!",
  },

  // Footer
  footer: {
    description: "Nền tảng B2B kết nối doanh nghiệp Hàn Quốc với thị trường Việt Nam. Khám phá sản phẩm công nghệ cao, kết nối đối tác chiến lược.",
    quickLinks: "Liên Kết Nhanh",
    categories: "Danh Mục",
    support: "Hỗ Trợ",
    contactUs: "Liên Hệ",
    copyright: "© 2026 Vietnam B2B Korea. Bản quyền được bảo lưu.",
    address: "Địa chỉ",
    phone: "Điện thoại",
    email: "Email",
  },

  // Common
  common: {
    viewAll: "Xem Tất Cả",
    loading: "Đang tải...",
    noResults: "Không tìm thấy kết quả",
    search: "Tìm kiếm",
    filter: "Lọc",
    sort: "Sắp xếp",
    newest: "Mới nhất",
    popular: "Phổ biến",
    priceAsc: "Giá tăng dần",
    priceDesc: "Giá giảm dần",
    page: "Trang",
    of: "trong",
    results: "kết quả",
    perPage: "mỗi trang",
    contactPrice: "Liên hệ",
    products: "sản phẩm",
    companies: "doanh nghiệp",
  },
};

export default translation;
